import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Person from "./Person";
import PersonCard from "./PersonCard";
import GridConfig from "./GridConfig";

export default class Persons extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'person',
            data: null,
            loading: true,
            configName: 'persons_grid',
            moduleName: 'اشخاص',
            popupComponent: null,
            topFilter: (
                <div className="pull-left" style={{ marginTop: "-3px" }}>
                    <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" id="person_ch1" onChange={e => this.setPersonFilter()} type="checkbox" value="1" defaultChecked="checked" /> <span>مشتریان</span></div>
                    <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" id="person_ch2" onChange={e => this.setPersonFilter()} type="checkbox" value="2" defaultChecked="checked" /> <span>فروشندگان</span></div>
                    <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" id="person_ch3" onChange={e => this.setPersonFilter()} type="checkbox" value="3" defaultChecked="checked" /> <span>اشخاص حقیقی</span></div>
                    <div className="pull-left mr-b-10 mr-l-10 small"><input className="hand" id="person_ch4" onChange={e => this.setPersonFilter()} type="checkbox" value="4" defaultChecked="checked" /> <span>اشخاص حقوقی</span></div>
                </div>)
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    setPersonFilter() {
        this.refreshData();
    }
    showPersonCard(id) {
        this.showComponents({ component: <PersonCard Caller={this} Id={id} />});
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Person Caller={this} Id={id} />});
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Person Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "code", caption: "", show: true },
                { field: "name", caption: "نام شخص", show: true },
                { field: "typeString", caption: "نوع شخص", show: true },
                { field: "groupName", caption: "گروه", show: true },
                { field: "phone", caption: "تلفن", show: true },
                { field: "city", caption: "شهر", show: true },
                //{ field: "remain", caption: "گردش حساب", show: true },
                //{ field: "tashkhis", caption: "تشخیص", show: true },
                { field: "genderString", caption: "جنسیت", show: false },
                { field: "codeEgtesadi", caption: "کداقتصادی", show: false },
                { field: "nationalId", caption: "شماره ملی", show: false },
                { field: "ostan", caption: "استان", show: false },
                { field: "shomareSabt", caption: "شماره ثبت", show: false },
                { field: "postalCode", caption: "کدپستی", show: false },
                { field: "fax", caption: "فکس", show: false },
                { field: "address", caption: "آدرس", show: false },
                { field: "email", caption: "ایمیل", show: false },
                { field: "website", caption: "وبسایت", show: false },
                { field: "note", caption: "یادداشت", show: false },
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.code}</a> } });
            if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'typeString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'groupName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'phone' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'city' && f.show) t.push({ field: f.field, headerName: f.caption });
            //if (f.field == 'remain' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remain) } });
            //if (f.field == 'tashkhis' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'genderString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'codeEgtesadi' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'nationalId' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'ostan' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'shomareSabt' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'postalCode' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'fax' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'address' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'email' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'website' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'note' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "85%" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="mr-10">
                            <div className="center-block">
                                {this.getToolBar(false)}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : 
                    [
                        this.state.lockScreen === 1 && this.lockScreen(),
                        this.getGlobalContainer(),
                        this.renderForm(),
                        this.renderPopupComponent(),
                    ];

        return contents;
    }
}